<template>
  <div class="tabs-block-flex">
    <div class="pt-tabs-wrapper">
      <ul class="pt-tabs-list">
        <li
          v-for="(league, index) in getLeagueViewData"
          :key="index"
          :value="league.name"
          class="pt-tab"
          @click="selectTeams(index)"
          :class="{
            'pt-tab--active': getSelectedLeague === league.name,
            'pt-tab--2': getLeagueViewData.length === 2,
            'pt-tab--3': getLeagueViewData.length === 3,
            'pt-tab--4': getLeagueViewData.length === 4
          }"
        >
          {{ league.name }}
        </li>
      </ul>
    </div>

    <div class="pt-teams" v-if="tabstype">
      <teams
        :content="getSelectedTeams"
        :selectedSlide="setActiveSlide"
        :config="config"
        :key="getSelectedLeagueId"
      ></teams>
    </div>
    <br />
    <div>
      <filter-teams></filter-teams>
    </div>
  </div>
</template>

<script>
import filterTeams from "@/components/filter-teams-component.vue";
import teams from "@/components/teams-component.vue";
import store from "@/store/store";

import { mapGetters } from "vuex";
export default {
  name: "Tabs",
  props: {
    config: Object,
    userPick: Object
  },
  components: {
    filterTeams,
    teams
  },
  computed: {
    ...mapGetters([
      "getLeagueViewData",
      "getSelectedTeams",
      "getSelectedLeague",
      "getSelectedLeagueId"
    ]),
    setActiveSlide() {
      if (
        this.userPick !== null &&
        this.userPick.domestic.leagueid === this.getSelectedLeagueId
      )
        return this.userPick.domestic.teamid;
      return 0;
    }
  },
  data: function() {
    return {
      tabstype: "",
      activeLeagueIndex: 0
    };
  },
  created: function() {
    this.tabstype = true;
  },
  methods: {
    selectTeams(selectedleague) {
      this.activeLeagueIndex = selectedleague;
      store.commit(
        "setDefaultLeagueTeam",
        this.getLeagueViewData[selectedleague].teams
      );
      store.commit(
        "setSelectedLeague",
        this.getLeagueViewData[selectedleague].name
      );
      store.commit(
        "setSelectedLeagueId",
        this.getLeagueViewData[selectedleague].id
      );
    }
  }
};
</script>

<style lang="scss">
.slider-content-one {
  display: flex;
  width: 100%;
  justify-content: center;
}
.pt-tab--2 {
  width: 50%;
}
.pt-tab--3 {
  width: calc(100% / 3);
}
.pt-tab--4 {
  width: 50%;
}
.pt-tab {
  border-bottom: var(--pyt-navigation-border);
  box-sizing: border-box;
  color: var(--pyt-navigation-color);
  cursor: pointer;
  list-style: none;
  overflow: hidden;
  padding: 10px;
  position: relative;
  text-align: center;
  text-overflow: ellipsis;
}
.pt-tab--active {
  background-color: var(--pyt-navigation-bg--active);
  border-bottom: var(--pyt-navigation-border--active);
  color: var(--pyt-navigation-color--active);
  font-weight: 500;
}

.pt-teams {
  position: relative;
}
.pt-tabs-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 0;
  position: relative;
  text-align: center;
}
.tabs-block-flex {
  margin: 0 auto;
  max-width: 1000px;
  padding-top: 25px;
  width: 100%;
}

@media (min-width: 956px) {
  .pt-tab {
    &--4 {
      width: 25%;
    }
    &--active {
      &:before {
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid var(--pyt-navigation-caret-bg);
        bottom: -10px;
        content: "";
        height: 0;
        left: calc(50% - 5px);
        position: absolute;
        width: 0;
      }
    }
    &s {
      &-wrapper {
        margin: 0 auto;
        width: 80%;
      }
    }
  }
}
</style>
